import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';

export type HolidayCardProps = {
  holiday: {
    id: number | string;
    name: string;
    date: string;
    daysUntil: number;
  };
};

const HolidayCard: React.FC<HolidayCardProps> = ({ holiday }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-card rounded-full border border-border px-4 py-2.5 min-h-[44px] hover:shadow-md transition-all flex items-center gap-2.5 group">
      <div className="p-1.5 bg-success/10 rounded-full group-hover:bg-success/20 transition-colors">
        <Calendar className="w-4 h-4 text-success" />
      </div>
      <span className="text-sm font-medium text-foreground whitespace-nowrap">{holiday?.name}</span>
      <span className="text-xs text-muted-foreground whitespace-nowrap">{t('{{count}}d', { count: holiday?.daysUntil })}</span>
    </div>
  );
};

export default HolidayCard;
